import styled from 'styled-components';

export const StatusLabel = styled.label`
  font-size: 12px;
  color: white;
  padding: 0.25rem 0.5rem;
  margin-left: 0.25rem;
  border-radius: 3px;
  background-color: #00426b;

  &.active {
    background-color: #079940;
  }

  &.pending {
    background-color: ${props => props.theme.colors.primaryAccent};
  }

  &.inactive {
    background-color: #be1e2d;
  }

  &.warning {
    background-color: #fceea1;
    color: #d67300;
  }
`;
